import _Number$parseInt from "@babel/runtime-corejs2/core-js/number/parse-int";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { subscribe, unsubscribe } from '@wh/message-bus';
import { abortable, SessionExistsError } from '../libs';
export var PassiveLoginNativeStrategy = /*#__PURE__*/function () {
  function PassiveLoginNativeStrategy(config) {
    _classCallCheck(this, PassiveLoginNativeStrategy);

    this.config = config;

    _defineProperty(this, "abortController", void 0);

    _defineProperty(this, "nativeLoginSubscriptionToken", void 0);
  }

  _createClass(PassiveLoginNativeStrategy, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.abortController = new AbortController();
                _context.next = 4;
                return _Promise.race([this.watchAbort(), this.watchLogin()]);

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                this.close();

                if (_context.t0 instanceof SessionExistsError) {
                  this.config.onLoginCallback();
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "close",
    value: function close() {
      if (!this.abortController) {
        return;
      }

      if (!this.abortController.signal.aborted) {
        this.abortController.abort();
      }

      if (!this.nativeLoginSubscriptionToken) {
        return;
      }

      unsubscribe(this.nativeLoginSubscriptionToken);
    }
  }, {
    key: "watchAbort",
    value: function watchAbort() {
      var _this = this;

      return new _Promise(function (_, reject) {
        var onAbortCallback = function onAbortCallback() {
          _this.abortController.signal.removeEventListener('abort', onAbortCallback);

          reject();
        };

        _this.abortController.signal.addEventListener('abort', onAbortCallback);
      });
    }
  }, {
    key: "watchLogin",
    value: function watchLogin() {
      var _this2 = this;

      return new _Promise(function (_, reject) {
        /**
         * Sportsbook native apps for UK emit `native.login` event with
         * payload of `1` (logged in) or `0` (not logged in).
         *
         * We attach to this event and when we receive `1` as payload
         * we then call CAS to perform session check.
         */
        _this2.nativeLoginSubscriptionToken = subscribe({
          topic: 'native.login',
          callback: function () {
            var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(envelope) {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!(_Number$parseInt(envelope.data, 10) !== 1)) {
                        _context2.next = 2;
                        break;
                      }

                      return _context2.abrupt("return");

                    case 2:
                      _context2.prev = 2;
                      _context2.next = 5;
                      return abortable(function () {
                        return _this2.config.casClient.init({
                          custLogin: true
                        });
                      }, {
                        signal: _this2.abortController.signal
                      });

                    case 5:
                      reject(new SessionExistsError());
                      _context2.next = 11;
                      break;

                    case 8:
                      _context2.prev = 8;
                      _context2.t0 = _context2["catch"](2);
                      reject(_context2.t0);

                    case 11:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[2, 8]]);
            }));

            function callback(_x) {
              return _callback.apply(this, arguments);
            }

            return callback;
          }()
        });
      });
    }
  }]);

  return PassiveLoginNativeStrategy;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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